<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__wrapper">
        <div class="footer__left">
          <router-link :to="translations.i18nRoute({ name: 'home' })" class="footer__logo">
            <img src="@icons/logo.svg" alt="logo">
            <p class="footer__logo-text">NEW GIFTS STORE</p>
          </router-link>
          <p>{{ companyInfo.companyAddress }}</p>
          <p>{{ companyInfo.companyName }} {{ t('footer.rights') }}</p>
          <a :href="'mailto:' + companyInfo.emailFrom">{{ companyInfo.emailFrom }}</a>
          <a :href="'tel:' + companyInfo.companyPhoneNumber">{{ companyInfo.companyPhoneNumber }}</a>
<!--          <div class="footer__left-images">-->
<!--            <img src="@images/mastercard.png" alt="mastercard">-->
<!--            <img src="@images/visa.png" alt="visa">-->
<!--          </div>-->
        </div>
        <div class="footer__right">
          <div class="footer__column">

          </div>
          <div class="footer__column">
            <router-link :to="translations.i18nRoute({ name: 'about' })">{{ t('footer.about') }}</router-link>
            <router-link :to="translations.i18nRoute({ name: 'contact' })">{{ t('footer.contact') }}</router-link>
            <router-link :to="translations.i18nRoute({ name: 'faq' })">{{ t('footer.faq') }}</router-link>
          </div>
          <div class="footer__column">
            <router-link :to="translations.i18nRoute({ name: 'terms' })">{{ t('docs.terms.title') }}</router-link>
            <router-link :to="translations.i18nRoute({ name: 'policy' })">{{ t('docs.policy.title') }}</router-link>
            <router-link :to="translations.i18nRoute({ name: 'description' })">{{ t('docs.description.title') }}</router-link>
            <ui-language-switcher :inFooter="true" />
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import translations from "@/core/helpers/translations.js";
import {useCompanyStore} from "@/stores/company.js";
import {computed} from "vue";
import {useI18n} from "vue-i18n";
import UiLanguageSwitcher from "@/components/ui/ui-language-switcher.vue";

const {t} = useI18n()
const companyStore = useCompanyStore()

const companyInfo = computed(() => {
  return companyStore.companyInfo ? companyStore.companyInfo : null
})
</script>

<style lang="scss" scoped>
.footer {
  margin-top: 50px;
  background-color: #1C1C1C;
  padding-block: 35px;

  &__wrapper {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  &__logo {
    display: flex;
    align-items: center;
    gap: 10px;

    &-text {
      color: $white !important;
      font-size: 16px !important;
      font-weight: 700 !important;
      line-height: 23.4px !important;
    }

    &::after {
      display: none;
    }
  }

  &__left {
    width: 450px;
    display: flex;
    flex-direction: column;
    gap: 15px;

    & p {
      color: rgba(255, 255, 255, 0.19);
      font-size: 13px;
      font-weight: 400;
      line-height: 18px;
    }

    & a {
      position: relative;
      width: fit-content;
      color: rgba(255, 255, 255, 0.90);
      font-size: 13px;
      font-weight: 400;
      line-height: 18px;

      &::after {
        content: "";
        position: absolute;
        bottom: -2px;
        left: 0;
        height: 2px;
        width: 0;
        transition: all .3s ease;
        background-color: $white;
      }

      @include hover {
        &::after {
          width: 100%;
        }
      }
    }

    &-images {
      display: flex;
      align-items: center;
      gap: 20px;
    }
  }

  &__right {
    display: flex;
    align-items: flex-start;
    gap: 40px;
  }

  &__column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;

    & a {
      transition: 0.2s;
      color: rgba(255, 255, 255, 0.60);
      font-size: 13px;
      font-weight: 400;
      line-height: 20.8px;

      @include hover {
        color: $white;
      }
    }
  }
}

@media (max-width: 1000px) {
  .footer {
    &__wrapper {
      flex-direction: column;
      align-items: center;
      gap: 50px;
    }

    &__left {
      align-items: center;

      & p {
        text-align: center;
      }
    }

    &__column {
      align-items: center;
    }
  }
}

@media (max-width: 550px) {
  .footer {
    &__left {
      width: 100%;
    }

    &__right {
      flex-direction: column;
      align-items: center;
    }
  }
}
</style>